import { environment } from "./src/environments/environment";

const getToken = () => {
  // Check if window and sessionStorage are defined
  if (typeof window !== "undefined" && typeof sessionStorage !== "undefined") {
    return sessionStorage.getItem("token");
  }
  return null; // Fallback if not in browser
};

export const GlobalComponent = {
  // Api Calling
  API_URL: "https://api-node.themesbrand.website/",
  // API_URL : 'http://127.0.0.1:3000/',
  base64EncodedAuthenticationKey: {
    Authorization: `Bearer ${getToken()}`,
  },

  // Auth Api
  //AUTH_API:"https://api-node.themesbrand.website/auth/",
  AUTH_API: environment.serverUrl + "/authentication/",

  // AUTH_API:"http://127.0.0.1:3000/auth/",

  // Products Api
  product: "apps/product",
  productDelete: "apps/product/",

  // Orders Api
  order: "apps/order",
  orderId: "apps/order/",

  // Customers Api
  customer: "apps/customer",
};
